const PRINT_ERROR_MESSAGES: Record<string, string> = {
  PRINTER_NOT_CONFIGURED: 'No hay una impresora configurada para este tipo de documento.',
  PRINTER_UNAVAILABLE: 'La impresora configurada no está disponible en Windows.',
  INVALID_PRINTER_ROLE: 'El destino de impresión no es válido.',
  INVALID_BASE64: 'El documento recibido no tiene un formato de impresión válido.',
  CONTENT_TOO_LARGE: 'El documento supera el tamaño permitido por Codenova Desktop.',
  PRINT_FAILED: 'Windows rechazó el trabajo de impresión.',
  BRIDGE_ERROR: 'No fue posible comunicarse con Codenova POS Desktop.',
};

export interface MappedPrintError {
  code?: string;
  title: string;
  message: string;
  original: unknown;
}

export const mapPrintError = (error: any): MappedPrintError => {
  const code = error?.code || error?.response?.data?.code || error?.response?.data?.type;
  const originalMessage = error?.response?.data?.message || error?.message;
  return {
    code,
    title: 'Error de impresión',
    message:
      (code && PRINT_ERROR_MESSAGES[code]) ||
      originalMessage ||
      'No fue posible completar la impresión.',
    original: error,
  };
};
